import { createAsyncThunk } from "@reduxjs/toolkit";
import OrdersApiService from "../../infrastructure/api/orders";
import { setMessage } from "../slices/message";

// Get My Orders
export const fetchMyOrders = createAsyncThunk(
  "orders/fetchMy",
  async (_, { dispatch, rejectWithValue }) => {
    try {
      const response = await OrdersApiService.getMyOrders();
      return response;
    } catch (error) {
      const message =
        error.response?.data?.message ||
        error.message ||
        "خطا در دریافت سفارشات";
      dispatch(setMessage(message));
      return rejectWithValue(message);
    }
  }
);

// Get Order Details
export const fetchOrderDetails = createAsyncThunk(
  "orders/fetchDetails",
  async (orderId, { dispatch, rejectWithValue }) => {
    try {
      const response = await OrdersApiService.getOrderDetails(orderId);
      return response;
    } catch (error) {
      const message =
        error.response?.data?.message ||
        error.message ||
        "خطا در دریافت جزئیات سفارش";
      dispatch(setMessage(message));
      return rejectWithValue(message);
    }
  }
);

// Create Order
export const createOrder = createAsyncThunk(
  "orders/create",
  async (orderData, { dispatch, rejectWithValue }) => {
    try {
      const response = await OrdersApiService.createOrder(orderData);
      dispatch(setMessage("سفارش با موفقیت ثبت شد"));
      return response;
    } catch (error) {
      const message =
        error.response?.data?.message || error.message || "خطا در ثبت سفارش";
      dispatch(setMessage(message));
      return rejectWithValue(message);
    }
  }
);

// Calculate Order Total
export const calculateOrderTotal = createAsyncThunk(
  "orders/calculateTotal",
  async (orderData, { dispatch, rejectWithValue }) => {
    try {
      const response = await OrdersApiService.calculateOrderTotal(orderData);
      return response;
    } catch (error) {
      const message =
        error.response?.data?.message ||
        error.message ||
        "خطا در محاسبه مبلغ سفارش";
      dispatch(setMessage(message));
      return rejectWithValue(message);
    }
  }
);

// Update Order Status
export const updateOrderStatus = createAsyncThunk(
  "orders/updateStatus",
  async ({ orderId, status }, { dispatch, rejectWithValue }) => {
    try {
      const response = await OrdersApiService.updateOrderStatus(
        orderId,
        status
      );
      dispatch(setMessage("وضعیت سفارش با موفقیت به‌روزرسانی شد"));
      return response;
    } catch (error) {
      const message =
        error.response?.data?.message ||
        error.message ||
        "خطا در به‌روزرسانی وضعیت سفارش";
      dispatch(setMessage(message));
      return rejectWithValue(message);
    }
  }
);

// Search Orders
export const searchOrders = createAsyncThunk(
  "orders/search",
  async (searchParams, { dispatch, rejectWithValue }) => {
    try {
      const response = await OrdersApiService.searchOrders(searchParams);
      return response;
    } catch (error) {
      const message =
        error.response?.data?.message ||
        error.message ||
        "خطا در جستجوی سفارشات";
      dispatch(setMessage(message));
      return rejectWithValue(message);
    }
  }
);
